import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <img
          src={`${process.env.PUBLIC_URL}/assets/logo_elharamain.png`}
          alt="شعار الحرمين"
          className="footer-logo"
        />
        <div className="footer-text">
          <p className="footer-org">رئاسة الشؤون الدينية بالمسجد الحرام والمسجد النبوي</p>
          <p className="footer-sub">
            بطاقات التهنئة بعيد الفطر المبارك ١٤٤٧هـ
            <span className="footer-sep"> — </span>
            خاص بالموظفين
          </p>
        </div>
      </div>
    </footer>
  );
}
